import React from "react";
import { Autocomplete, Chip, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";

import checkedIcon from "../../assets/icons/checked.svg";
import CustomIcon from "./CustomIcon";

const CustomSelectV2 = ({
  label = "Select Label",
  value,
  options = [],
  size = "small",
  width = 150,
  background = "transparent",
  multiple = false,
  limitTags = 4,
  disableClearable = true,
  displayCheckedIcon = true,
  onChange = (event, newValue) => {},
  getOptionLabel = (option) => {
    return option.label ?? option;
  },
  isOptionEqualToValue = (option, value) => option.value === value?.value,
  isInvalid = false,
  ...others
}) => {
  return (
    <Autocomplete
      disablePortal
      multiple={multiple}
      limitTags={limitTags}
      value={value || null}
      options={options}
      sx={{ minWidth: width }}
      onChange={onChange}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      renderOption={(props, option, state) => (
        <li
          {...props}
          sx={{
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "inline-flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "4px 0",
            }}
          >
            <Typography
              sx={{
                color: "var(--secondary)",
                fontSize: "14px",
                letterSpacing: "-0.47px",
                padding: "0 8px",
              }}
            >
              {getOptionLabel(option)}
            </Typography>
            {displayCheckedIcon && state.selected && (
              <CustomIcon
                svgIcon={checkedIcon}
                fontSize="small"
                imgStyles={{ height: 26, width: 26 }}
              />
            )}
          </Box>
        </li>
      )}
      renderTags={(value, getTagProps) => {
        const numTags = value.length;
        return (
          <>
            {value.slice(0, limitTags).map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                key={index}
                label={option.name}
              />
            ))}
            {numTags > limitTags && ` + ${numTags - limitTags}`}
          </>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          sx={{
            background: background,
            ".MuiFormLabel-root": { color: "#50566E" },
            "& .MuiInputBase-root": {
              color: "#1C2238",
              "& fieldset": {
                borderColor: "#D3D8E3",
              },
              "&:hover fieldset": {
                borderColor: "#D3D8E3",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#D3D8E3",
              },
              "& .MuiChip-root": {
                height: 25,
                fontSize: 12,
                letterSpacing: 0,
                lineHeight: "14px",
                color: "var(--secondary)",
                background: "var(--gray-4)",
                "& .MuiSvgIcon-root": {
                  width: 17,
                  fill: "var(--gray-2)",
                },
              },
            },
          }}
          size={size}
          error={isInvalid}
        />
      )}
      disableClearable={disableClearable}
      {...others}
    />
  );
};

export default CustomSelectV2;
